import { FormattedMessage } from 'react-intl';
import React from 'react';
import type { EmploymentEmployeeCategoryEnum, EventSourceEnum } from 'app/types';
import EventSourceChip from './components/EventSourceChip';

type RenderersType = {
  employeeCategory: EmploymentEmployeeCategoryEnum[];
  eventSource: EventSourceEnum;
};

const renderers = {
  employeeCategory: (value: RenderersType['employeeCategory']) => {
    return Array.isArray(value) ? (
      <table>
        <tbody>
          {value.map((item, index) => (
            <tr key={index}>
              <td>
                <FormattedMessage id={`employees.detail.employeeCategory.${item}`} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : null;
  },
  eventSource: (value: RenderersType['eventSource']) => {
    return <EventSourceChip value={value} />;
  },
};

export default renderers;
